import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
// import { confirmAlert } from "react-confirm-alert";
import { LoadScript } from "@react-google-maps/api";
import {
  AutoComplete,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
  Select,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import scan_unchecked_red from "../../image/scan_unchecked_red.png";
import scan_check_green from "../../image/scan_check_green.png";
import SearchIcon from "../../image/SearchIcon.svg";
import wrongicon from "../../image/wrongicon.png";
import dayjs from "dayjs";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";

import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  // ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

import {
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { authUserData } from "../../utils/Helper";
import SelectRouteModal from "./SelectRouteModal";

import { useRouteNameChanges } from "../RouteNameProvider";
import EndLocationAddress from "./EndLocationAddress";
const { Option } = Select;
const { Panel } = Collapse;
const libraries = ["places"];
const AddRoutePickupPackage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { driverState, setDriverState } = useRouteNameChanges();
  const [driverForm] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const auth_package_columns = authUserData()?.packages_columns;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [checkedRouted, setCheckedRouted] = useState("False");
  const [newPackageAdded, setNewPackageAdded] = useState(false);
  const [packageId, setpackageId] = useState(null);
  const [zones, setZones] = useState([]);
  const [loadingSuburb, setLoadingSuburb] = useState(false);
  const [loadingPostal, setLoadingPostal] = useState(false);
  const [deliverydate, setdeliverydate] = useState(null);
  const [suburbList, setSuburbList] = useState([]);
  const [postalList, setPostalList] = useState([]);
  const [states, setStates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [driverList, setDriverList] = useState([]);

  const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleRoute, setIsModalVisibleRoute] = useState(false);
  const [showViewOptimizeButton, setShowViewOptimizeButton] = useState(false);
  const [showOptimizeButton, setShowOptimizeButton] = useState(false);
  const [showAddRouteButton, setShowAddRouteButton] = useState(true);
  // const [selectedRowParcels, setSelectedRowParcels] = useState([]);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [checked, setChecked] = useState(false);
  const formRef = useRef();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 300,
    search: "",
    total: 0,
  });
  const intialFilter = {
    state: "",
    zone_id: [],
    suburb_id: [],
    postcode_name: [],
    // zone:"",
    driver_id: "",
    unrouted: "False",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);
  //   const [driverForm] = Form.useForm();
  //   const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [options2, setOptions2] = useState([]);
  //   const [driverList, setDriverList] = useState([]);

  // const { Option } = Select;
  const initialState = {
    start_street_address: authUserData()?.pl_company_address
      ? authUserData()?.pl_company_address
      : null,
    start_suburb: authUserData()?.pl_company_suburb
      ? authUserData()?.pl_company_suburb
      : null,
    start_state: authUserData()?.pl_company_state
      ? authUserData()?.pl_company_state
      : null,
    start_postcode: authUserData()?.pl_company_postcode
      ? authUserData()?.pl_company_postcode
      : null,
    start_additional_details: authUserData()?.pl_company_additional_detail
      ? authUserData()?.pl_company_additional_detail
      : null,
    addresses: [
      {
        end_street_address: null,
        end_suburb: null,
        end_state: null,
        end_postcode: null,
        end_additional_details: null,
      },
    ],

    packages: selectedRow,
    driver: null,
    route_name: "",
    created_at: moment(),
  };
  const [address, setAddress] = useState(initialState);
  const [checkedDisable, setCheckedDisable] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const handleFormChange = (values) => {
    const isValid = Object.values(values).every(
      (value) => value !== undefined && value !== ""
    );
    setFormValid(isValid); // Update form validation state
  };
  // const currentTime = moment().format("dddd Do of MMMM YYYY h:mm A (Z)");
  useEffect(() => {
    if (
      auth_package_columns.length > 0 &&
      !(
        auth_package_columns.length === 1 &&
        auth_package_columns[0] === "operation"
      )
    ) {
      setCheckedList(auth_package_columns);
    }
  }, []);
  useEffect(() => {
    const getEmployeeList = async () => {
      setLoading(true);

      // Merge state and stateFilter objects
      const queryParamsObject = {
        ...state,
        created_date: startDate || null,
        is_checked: checked || null,
        state: stateFilter?.state || null,
        driver_id: stateFilter?.driver_id || null,
        unrouted: "False",
        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
        assign_to: !checked ? "" : "unassigned",
      };

      // Filter out null or undefined values
      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      const payload = {
        zone_id: stateFilter?.zone_id || [],
        suburb_id: stateFilter?.suburb_id || [],
        postcode_name: stateFilter?.postcode_name || [],
      };

      try {
        const apiResponse = await patchRequest(
          // `package-model/package-by-driver-and-unassign/?assign_to=unassigned&is_checked=true&${queryParams}`,
          `package-model/package-by-driver-and-unassign/?is_checked=true&${queryParams}`,
          payload
        );

        if (apiResponse.data.results.success) {
          setEmployeeList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        }
      } catch (error) {
        ErrorNotificationMsg(t("Error Fetching Package List"));
      } finally {
        setLoading(false);
      }
    };

    getEmployeeList();
  }, [state, newPackageAdded, reload, t, stateFilter?.driver_id]);

  // const handleCheckboxChangeRouted = (e) => {
  //   const isChecked = e.target.checked; // Get the checked state (true/false)

  //   // Set the state to the corresponding string value
  //   setCheckedRouted(isChecked ? 'True' : 'False');

  // };
  useEffect(() => {
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getzoneByState(authUserData()?.state)
      : getzoneByState(1);

    getDriverName();
  }, []);
  const [checkedList, setCheckedList] = useState([
    "parcel_no",
    "created_at",
    "is_scanned",
    "suburb",
    "status",
    "zone",
    "state",
    "unrouted",
    "postcode",
    "assigned_to",
    "hawb",
    "customer_code",
    "customer_name",
    "company",
    "customer_address",
    "description_of_goods",
    "count",
    "landed",
    "weight",
    "shipper_code",
    "shipper_name",
    "shipper_address",
    "shipper_city",
    "shipper_state",
    "shipper_postcode",
    "shipper_country",
    "origin",
    "port",
    "total_value",
    "goods_currency",
    "sac",
    "fr_reference",
    "sub_master",
    "pkg_type",
    "cyber_vendor_account",
    "customs_code",
    "operation",
    "latitude",
    "longitude",
  ]);
  // const generateRouteName = (driverName, date) => {
  //   const formattedDate = date
  //     ? moment(date).format("DD-MM-YYYY")
  //     : moment().format("DD-MM-YYYY");
  //   const currentTime = new Date().toLocaleTimeString("en-GB", {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     second: "2-digit",
  //     hour12: true,
  //   });
  //   return `${driverName} - ${formattedDate} ${currentTime}`;
  // };
  const generateRouteName = (driverName, date) => {
    const formattedDate = date
      ? moment(date).format("DD/MM/YYYY")
      : moment().format("DD/MM/YYYY");
    const currentTime = new Date().toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Ensures the time is in 12-hour format with AM/PM
    });
    return `${driverName} - ${formattedDate}, ${currentTime}`;
  };

  const handleSearch = useCallback(
    debounce((value) => {
      const service = new window.google.maps.places.AutocompleteService();
      if (value !== "") {
        service.getPlacePredictions({ input: value }, (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setOptions(
              predictions.map((prediction) => ({
                value: prediction.description,
                place_id: prediction.place_id,
              }))
            );
            setLoading(false);
          } else {
            setOptions([]);
            setLoading(false);
          }
        });
      } else {
        setOptions([]);
        setLoading(false);
        setAddress((prevstate) => ({
          ...prevstate,
          start_street_address: "",
          start_suburb: "",
          start_state: "",
          start_postcode: "",
        }));
        form.setFieldsValue({
          start_street_address: "",
          start_suburb: "",
          start_state: "",
          start_postcode: "",
        });
      }
    }, 300),
    []
  );
  const disabledDate = (current) => {
    // Can not select days before today
    return current && current < dayjs().startOf("day");
  };

  const handleDateChange = (date) => {
    // const formattedDate = moment(date).format("DD-MM-YYYY");
    setdeliverydate(date);
    setAddress((prevstate) => {
      const driverName =
        driverList?.find((driver) => driver.id === prevstate.driver)?.name ||
        "";
      const routeName = generateRouteName(driverName, date);

      form.setFieldsValue({ route_name: routeName });

      return {
        ...prevstate,
        created_at: date,
        route_name: routeName,
      };
    });
    // form.setFieldsValue({
    //   ...address,
    //   created_at: date,
    //   route_name: routeName,
    // });
  };
  const handleCheckboxChangeDisbale = (isSelected) => {
    setCheckedDisable(isSelected);
  };
  const handleSearch2 = useCallback(
    debounce((value) => {
      // setLoading(true);

      const service = new window.google.maps.places.AutocompleteService();
      if (value !== "") {
        service.getPlacePredictions({ input: value }, (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setOptions2(
              predictions.map((prediction) => ({
                value: prediction.description,
                place_id: prediction.place_id,
              }))
            );
            setLoading(false);
          } else {
            setOptions2([]);
            setLoading(false);
          }
        });
      } else {
        setOptions2([]);
        setLoading(false);
        setAddress((prevstate) => ({
          ...prevstate,
          end_street_address: "",
          end_suburb: "",
          end_state: "",
          end_postcode: "",
        }));
        form.setFieldsValue({
          end_street_address: "",
          end_suburb: "",
          end_state: "",
          end_postcode: "",
        });
      }
    }, 300),
    []
  );
  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setAddress((prevstate) => ({
            ...prevstate,
            start_street_address: place.formatted_address,
            start_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            start_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            start_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          }));
          form.setFieldsValue({
            start_street_address: place.formatted_address,
            start_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            start_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            start_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          });
        }
      });
    }
  };
  const handleSelect2 = (value) => {
    const selected = options2.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setAddress((prevstate) => ({
            ...prevstate,
            end_street_address: place.formatted_address,
            end_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            end_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            end_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          }));
          form.setFieldsValue({
            end_street_address: place.formatted_address,
            end_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            end_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            end_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          });
        }
      });
    }
  };

  const handleSubmit = async () => {
    let payload = {
      route_name: address?.route_name,
      start_street_address: address?.start_street_address,
      start_suburb: address?.start_suburb,
      start_state: address?.start_state,
      start_postcode: address?.start_postcode,
      start_additional_details: address?.start_additional_details,
      addresses:
        address.addresses &&
        address.addresses.every(
          (person) =>
            person.end_street_address === null &&
            person.end_suburb === null &&
            person.end_state === null &&
            person.end_postcode === null &&
            person.end_additional_details === null
        )
          ? []
          : address.addresses,
      packages: selectedRow ? selectedRow : [],
      // packages: selectedRow?selectedRow:[],
      driver: address?.driver,
      created_at: address?.created_at
        ? moment(address.created_at).format("DD-MM-YYYY") // Format the date here
        : null,
    };
    setLoading(true);
    setLoadingButton(true);
    try {
      let apiResponse = await postRequest(
        "route/package-list-formatted/",
        payload
      );

      if (apiResponse.data.success) {
        setAddress((prevstate) => ({
          ...prevstate,
          route_name: "",
          start_street_address: null,
          start_suburb: null,
          start_state: null,
          start_postcode: null,
          start_additional_details: null,
          end_street_address: null,
          end_suburb: null,
          end_state: null,
          end_postcode: null,
          end_additional_details: null,
          packages: [],
          driver: null,
          created_at: null,
        }));
        driverForm.resetFields();
        form.resetFields();

        const { driver, id } = apiResponse.data.route_data;

        setDriverState((prevState) => ({
          ...prevState,
          driver: driver,
          route_name: id,
        }));

        navigate(`/optimized-route`);
      } else {
        console.log("API call was not successful.");
        setLoading(false);
        setLoadingButton(false);
      }
    } catch (error) {
      console.error("Error in API call:", error);
      setLoading(false);
      setLoadingButton(false);
    }
  };
  const handleStatus = async (assignedToId, packageId, driverId) => {
    setLoading(true);

    const payload = {
      id: assignedToId, // assigned_to_id is the assignedToId here
      packages: [packageId], // packages array with the id of the record
      driver: driverId, // selected driver's id
    };

    try {
      // Call your API here with the constructed payload
      const response = await postRequest("assign-package-to-driver/", payload);

      if (response.data.success) {
        // Update the state to reflect the change in the dropdown
        setEmployeeList((prevState) =>
          prevState.map((item) =>
            item.id === packageId
              ? {
                  ...item,
                  assigned_to_id: response?.data?.data?.id,
                  assigned_to: { ...item.assigned_to, id: driverId },
                }
              : item
          )
        );
      } else {
        console.error("Error assigning driver", response.data.message);
        // Optionally, display an error message or handle the error case
      }
    } catch (error) {
      console.error("API call failed", error);
      // Optionally, display an error message or handle the error case
    } finally {
      setLoading(false);
    }
  };

  const [columns, setColumns] = useState([]);

  const allColumns = [
    { key: "parcel_no", title: "Parcel Number" },
    { key: "created_at", title: "Schedule Date" },
    { key: "is_scanned", title: "Is Scanned" },
    { key: "status", title: "Status" },
    { key: "unrouted", title: "Unrouted" },
    { key: "suburb", title: "Suburb" },
    { key: "zone", title: "Zone" },
    { key: "state", title: "State" },
    { key: "latitude", title: "Latitude" },
    { key: "longitude", title: "Longitude" },
    { key: "postcode", title: "Postcode" },
    { key: "assigned_to", title: "Assigned Driver" },
    { key: "hawb", title: "HAWB" },
    { key: "customer_code", title: "Customer Code" },
    { key: "customer_name", title: "Customer Name" },
    { key: "company", title: "Company" },
    { key: "customer_address", title: "Customer Address" },
    { key: "description_of_goods", title: "Description of Goods" },
    { key: "count", title: "Count" },
    { key: "landed", title: "Landed" },
    { key: "weight", title: "Weight" },
    { key: "shipper_code", title: "Shipper Code" },
    { key: "shipper_name", title: "Shipper Name" },
    { key: "shipper_address", title: "Shipper Address" },
    { key: "shipper_city", title: "Shipper City" },
    { key: "shipper_state", title: "Shipper State" },
    { key: "shipper_postcode", title: "Shipper Postcode" },
    { key: "shipper_country", title: "Shipper Country" },
    { key: "origin", title: "Origin" },
    { key: "port", title: "Port" },
    { key: "total_value", title: "Total Value" },
    { key: "goods_currency", title: "Goods Currency" },
    { key: "sac", title: "SAC" },
    { key: "fr_reference", title: "FR Reference" },
    { key: "sub_master", title: "Sub Master" },
    { key: "pkg_type", title: "Package Type" },
    { key: "cyber_vendor_account", title: "Cyber Vendor Account" },
    { key: "customs_code", title: "Customs Code" },
    { key: "operation", title: "Action" },
  ];
  useEffect(() => {
    const updatedColumns = [
      // Define columns here
      {
        title: "Parcel Number",
        dataIndex: "parcel_no",
        key: "parcel_no",
        sorter: true,
        width: 100,
      },
      {
        title: "HAWB",
        dataIndex: "hawb",
        key: "hawb",
        sorter: true,
        width: 150,
      },
      // {
      //   title: "Schedule Date",
      //   dataIndex: "created_date",
      //   key: "created_date",
      //   sorter: true,
      //   width: 150,
      //   render: (text) => (
      //     <Tooltip title={text}>
      //       <div className="text-ellipsis">
      //         {moment(text).format("DD-MM-YYYY")}
      //       </div>
      //     </Tooltip>
      //   ),
      // },
      {
        title: "Schedule Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
        width: 150,
        render: (text) => (
          // <Tooltip title={text}>
          <div className="text-ellipsis">
            {text ? moment(text, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY") : "-"}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Is Scanned",
        dataIndex: "is_scanned",
        key: "is_scanned",
        sorter: true,
        width: 120,
        render: (text) => (
          <div className="text-ellipsis">
            {text ? (
              <img
                src={scan_check_green} // Replace with the actual path to the 'Yes' image
                alt="Yes"
                style={{ width: 20, height: 20, Color: "rgba(0, 128, 0, 0.5)" }}
              />
            ) : (
              <img
                src={scan_unchecked_red} // Replace with the actual path to the 'No' image
                alt="No"
                style={{ width: 20, height: 20 }}
              />
            )}
          </div>
        ),
      },
      {
        title: "Unrouted",
        dataIndex: "unrouted",
        key: "unrouted",
        sorter: true,
        width: 180,
        render: (text) => (
          <div className="text-ellipsis">
            {text ? (
              <img
                src={wrongicon} // Replace with the actual path to the 'Yes' image
                alt="Yes"
                style={{ width: 20, height: 20, Color: "rgba(0, 128, 0, 0.5)" }}
              />
            ) : (
              // <img
              //   src={scan_unchecked_red} // Replace with the actual path to the 'No' image
              //   alt="No"
              //   style={{ width: 20, height: 20 }}
              // />
              "-"
            )}
          </div>
        ),
      },
      {
        title: "Suburb",
        dataIndex: "suburb_name",
        key: "suburb",
        sorter: true,
        width: 180,
      },
      {
        title: "Latitude",
        dataIndex: "coordinates",
        key: "latitude",
        sorter: true,
        render: (coordinates) => coordinates?.latitude || "N/A",
        width: 150,
      },
      {
        title: "Longitude",
        dataIndex: "coordinates",
        key: "longitude",
        sorter: true,
        render: (coordinates) => coordinates?.longitude || "N/A",
        width: 150,
      },
      {
        title: "Run",
        dataIndex: "zone_name",
        key: "zone",
        sorter: true,
        width: 180,
      },
      {
        title: "State",
        dataIndex: "state_name",
        key: "state",
        sorter: true,
        width: 150,
      },
      {
        title: "Postcode",
        dataIndex: "postcode_name",
        key: "postcode",
        sorter: true,
        width: 150,
      },
      {
        title: "Company",
        dataIndex: "company_name",
        key: "company",
        sorter: true,
        width: 150,
      },

      {
        title: "Assigned Driver",
        dataIndex: "assigned_to",
        key: "assigned_to",
        sorter: true,
        width: 150,
        render: (assigned_to, record) =>
          driverList?.length > 0 ? (
            <Select
              className="gridselect"
              onChange={(value) =>
                handleStatus(record.assigned_to_id, record.id, value)
              }
              showArrow
              placeholder="Select Driver"
              value={
                assigned_to === "unassigned" ? "unassigned" : assigned_to?.id
              }
              disabled
            >
              {driverList?.map((driver) => (
                <Option key={driver.id} value={driver.id}>
                  {driver.name}
                </Option>
              ))}
            </Select>
          ) : (
            <span>Loading...</span>
          ),
      },

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: true,
        width: 200,
      },
      {
        title: "Customer Code",
        dataIndex: "customer_code",
        key: "customer_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Name",
        dataIndex: "customer_name",
        key: "customer_name",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Address",
        dataIndex: "customer_address",
        key: "customer_address",
        sorter: true,
        width: 200,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Description of Goods",
        dataIndex: "description_of_goods",
        key: "description_of_goods",
        sorter: true,
        width: 150,
      },
      {
        title: "Count",
        dataIndex: "count",
        key: "count",
        sorter: true,
        width: 100,
      },
      {
        title: "Landed",
        dataIndex: "landed",
        key: "landed",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "Weight",
        dataIndex: "weight",
        key: "weight",
        sorter: true,
        width: 100,
      },
      {
        title: "Shipper Code",
        dataIndex: "shipper_code",
        key: "shipper_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Name",
        dataIndex: "shipper_name",
        key: "shipper_name",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Shipper Address",
        dataIndex: "shipper_address",
        key: "shipper_address",
        sorter: true,
        width: 200,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Shipper City",
        dataIndex: "shipper_city",
        key: "shipper_city",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper State",
        dataIndex: "shipper_state",
        key: "shipper_state",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Postcode",
        dataIndex: "shipper_postcode",
        key: "shipper_postcode",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Country",
        dataIndex: "shipper_country",
        key: "shipper_country",
        sorter: true,
        width: 150,
      },
      {
        title: "Origin",
        dataIndex: "origin",
        key: "origin",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Port",
        dataIndex: "port",
        key: "port",
        sorter: true,
        width: 150,
      },
      {
        title: "Total Value",
        dataIndex: "total_value",
        key: "total_value",
        sorter: true,
        width: 150,
      },
      {
        title: "Goods Currency",
        dataIndex: "goods_currency",
        key: "goods_currency",
        sorter: true,
        width: 150,
      },
      {
        title: "SAC",
        dataIndex: "sac",
        key: "sac",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "FR Reference",
        dataIndex: "fr_reference",
        key: "fr_reference",
        sorter: true,
        width: 150,
      },
      {
        title: "Sub Master",
        dataIndex: "sub_master",
        key: "sub_master",
        sorter: true,
        width: 150,
      },
      {
        title: "Package Type",
        dataIndex: "pkg_type",
        key: "pkg_type",
        sorter: true,
        width: 100,
      },
      {
        title: "Cyber Vendor Account",
        dataIndex: "cyber_vendor_account",
        key: "cyber_vendor_account",
        sorter: true,
        width: 150,
      },
      {
        title: "Customs Code",
        dataIndex: "customs_code",
        key: "customs_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 100,
        render: (text, record) => (
          <Space>
            {/* <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Edit</span>}
            > */}
            {authUserData()?.permission.includes("package|change_route") && (
              <Link to={`/add-route/edit/${btoa(record.id)}`}>
                <Editicon onClick={() => handleEdit(record.id)} />
              </Link>
            )}
            {/* </Tooltip> */}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={<span style={{ color: "#fff" }}>Archive</span>}
            > */}
            {authUserData()?.permission.includes("package|delete_route") && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                onConfirm={() => handleArchive(record.id)}
              >
                <Archive style={{ cursor: "pointer" }} />
              </Popconfirm>
            )}
            {/* </Tooltip> */}
          </Space>
        ),
      },
    ].filter((column) => checkedList.includes(column.key));
    setColumns(updatedColumns);
  }, [checkedList, driverList]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleViewOptimizedRoute = () => {
    setIsModalVisible(true);
  };
  const handleSelectRoute = () => {
    setIsModalVisibleRoute(true);
  };
  // Function to convert parcel_no to string and trim it
  const getTrimmedParcelNo = (parcel_no) => {
    return parcel_no ? parcel_no?.toString().trim() : "";
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const getDriverName = async () => {
    try {
      // setapiLoading(true);
      const response = await getRequest("employee/drivers-list/");
      const { data } = response.data;

      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);
      // setapiLoading(false);
    } catch (error) {
      // setapiLoading(false);
    }
  };

  const handleAssignDriver = async (driverId = "", id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await patchRequest("assign-package-to-driver/update/", {
        packages: ids,
        driver: driverId,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;
        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("package assigned successfully"));
        setSelectedRow([]);
        driverForm.resetFields(); // Reset only the driver form
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
      driverForm.resetFields(); // Reset only the driver form
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
    driverForm.resetFields(); // Reset only the driver form
    setPopConfirmVisible(false);
  };

  const handleDriverFilter = async (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
    }));
    try {
      const apiResponse = await getRequest(`employee/${value}/`);

      if (apiResponse.data.success) {
        const selectedWeight = driverList?.find((zone) => zone.id === value);
        const weightName = selectedWeight ? selectedWeight.name : "";
        const selectedDriver = driverList?.find(
          (driver) => driver.id === value
        );
        const driverName = selectedDriver ? selectedDriver.name : "";
        // const currentTime = new Date().toLocaleString("en-GB", {
        //   day: "2-digit",
        //   month: "2-digit",
        //   year: "numeric",
        //   hour: "2-digit",
        //   minute: "2-digit",
        //   second: "2-digit",
        //   hour12: true,
        // });
        const routeName = generateRouteName(driverName, address?.created_at);
        // const routeName = `${weightName} - ${currentTime}`;
        setAddress((prevstate) => ({
          ...prevstate,
          route_name: routeName,
          driver: value,
          end_additional_details: apiResponse?.data?.data?.additional_details,
          end_postcode: apiResponse?.data?.data?.postcode,
          end_state: apiResponse?.data?.data?.state,
          end_suburb: apiResponse?.data?.data?.suburb,
          end_street_address: apiResponse?.data?.data?.street_address,

          // packages:selectedRow,
        }));

        form.setFieldsValue({
          route_name: routeName,
          end_additional_details: apiResponse?.data?.data?.additional_details,
          end_postcode: apiResponse?.data?.data?.postcode,
          end_state: apiResponse?.data?.data?.state,
          end_suburb: apiResponse?.data?.data?.suburb,
          end_street_address: apiResponse?.data?.data?.street_address,
        });
        // setChecked( apiResponse?.data?.data?.term_condition_accept)
      }
    } catch (error) {
      // ErrorNotificationMsg(t("error_in_list_employee"));
      const selectedWeight = driverList?.find((zone) => zone.id === value);
      const weightName = selectedWeight ? selectedWeight.name : "";
      const selectedDriver = driverList?.find((driver) => driver.id === value);
      const driverName = selectedDriver ? selectedDriver.name : "";
      // Set the route_name with the selected driver's name
      // const currentTime = new Date().toLocaleString(); // You can customize the time format if needed
      // const routeName = `${weightName} - ${currentTime}`;
      // const currentTime = new Date().toLocaleString("en-GB", {
      //   day: "2-digit",
      //   month: "2-digit",
      //   year: "numeric",
      //   hour: "2-digit",
      //   minute: "2-digit",
      //   second: "2-digit",
      //   hour12: true,
      // });
      const routeName = generateRouteName(driverName, address?.created_at);
      // const routeName = `${weightName} - ${currentTime}`;
      setAddress((prevstate) => ({
        ...prevstate,
        route_name: routeName,
        driver: value,

        // packages:selectedRow,
      }));

      form.setFieldsValue({ route_name: routeName });
    }
    // const driverName = apiResponse?.data?.data?.driver_name;
  };

  // const getStateByCountry = async (id) => {
  //   const stateResponse = await getRequest(
  //     "state/?no_pagination=true&country_id=" + id
  //   );

  //   setStates(stateResponse?.data?.data);
  // };
  const getStateByCountry = async (id) => {
    // Use an empty string if `id` is not provided (null, undefined, etc.)
    const countryId = id || "";

    // Make the API request with the appropriate country_id
    const stateResponse = await getRequest(
      `state/?no_pagination=true&country_id=${countryId}`
    );

    // Check if the response contains the expected data and update states
    if (stateResponse?.data?.data) {
      setStates(stateResponse.data.data);
    } else {
      // Optionally, handle the case when the response doesn't contain valid data
      setStates([]);
    }
  };
  const handleStateSelectChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      state: value,
      zone_id: [],
      suburb_id: [],
      postcode_name: [],
      // suburb: null,
      // zone:null,
    }));

    formRef.current.setFieldsValue({
      zone: undefined,
      suburb: undefined,
      postcode: undefined,
    });
    // setZones([]);
    setSuburbList([]);
    setPostalList([]);
    setZones([]);
    getzoneByState(value);
  };
  // const getzoneByState = async (id) => {
  //   const zoneResponse = await getRequest(
  //     "zone/?no_pagination=true&state_id=" + id
  //   );

  //   setZones(zoneResponse?.data?.data);
  // };
  const getzoneByState = async (id) => {
    // If id is not provided (null, undefined, or falsy), use an empty string
    const stateId = id || "";

    // Call the API with the appropriate state_id
    const zoneResponse = await getRequest(
      `zone/?no_pagination=true&state_id=${stateId}`
    );

    // Set the zones data if the response is valid
    if (zoneResponse?.data?.data) {
      setZones(zoneResponse.data.data);
    } else {
      // Optionally, handle the case when the response doesn't contain valid data
      setZones([]);
    }
  };

  // const handlezoneChange = (selectedZones) => {
  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     zone_id: selectedZones,
  //     suburb_id: [],
  //     postcode_name: [],
  //   }));

  //   formRef.current.setFieldsValue({ suburb: undefined, postcode: undefined });
  //   setSuburbList([]);
  //   setPostalList([]);
  //   getSuburbByzone(selectedZones);
  // };

  const handlezoneChange = (selectedZones) => {
    setStateFilter((prevState) => ({
      ...prevState,
      zone_id: selectedZones,
      suburb_id: [],
      postcode_name: [],
    }));

    formRef.current.setFieldsValue({ suburb: undefined, postcode: undefined });
    setSuburbList([]);
    setPostalList([]);
    // getSuburbByzone(selectedZones);
    getPostalByZone(selectedZones);
  };
  // const getPostalByZone = async (zoneIds) => {
  //   setLoadingPostal(true);
  //   try {
  //     const payload = { zone_ids: zoneIds }; // Prepare the payload with zoneId array
  //     const postalResponse = await patchRequest(
  //       "zone/zone-by-pincode-filter/?no_pagination=True",
  //       payload
  //     );

  //     if (postalResponse?.data?.success) {
  //       setPostalList(postalResponse?.data?.data);
  //       setLoadingPostal(false);
  //     }
  //   } catch {
  //     ErrorNotificationMsg(t("Error fetching postal"));
  //     setLoadingPostal(true);
  //   }
  // };

  const getPostalByZone = async (zoneIds) => {
    setLoadingPostal(true);
    setLoadingSuburb(true);
    try {
      const payload = { zone_ids: zoneIds }; // Prepare the payload with zoneId array

      // Call both APIs in parallel using Promise.all
      const [postalResponse, suburbResponse] = await Promise.all([
        patchRequest(
          "zone/zone-by-pincode-filter/?no_pagination=True",
          payload
        ),
        patchRequest("zone/zone-by-suburb-filter/?no_pagination=True", payload),
      ]);

      // Handle the response for the postal data
      if (postalResponse?.data?.success) {
        setPostalList(postalResponse?.data?.data);
      }

      // Handle the response for the suburb data
      if (suburbResponse?.data?.success) {
        setSuburbList(suburbResponse?.data?.data); // Assuming you have a function or state to handle suburb data
      }

      setLoadingPostal(false);
      setLoadingSuburb(false);
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching postal or suburb data"));
      setLoadingPostal(false);
      setLoadingSuburb(false);
    }
  };
  // const getSuburbByPostcode = async (postcodeIds) => {
  //   setLoadingSuburb(true);

  //   try {
  //     const payload = { postcode_name: postcodeIds }; // Prepare the payload with zoneId array
  //     const suburbResponse = await patchRequest(
  //       "pincode/pincode-by-suburb-filter/?no_pagination=true",
  //       payload
  //     );
  //     if (suburbResponse?.data?.success) {
  //       setSuburbList(suburbResponse?.data?.data);
  //       setLoadingSuburb(false);
  //     }
  //   } catch {
  //     ErrorNotificationMsg(t("Error fetching suburb"));
  //     setLoadingSuburb(false);
  //   }
  // };
  const getSuburbByzone = async (zoneIds) => {
    setLoadingSuburb(true);
    try {
      const payload = { zone_ids: zoneIds }; // Prepare the payload with zoneId array
      const suburbResponse = await patchRequest(
        "package-model/zone-by-suburb-filter/",
        payload
      );

      if (suburbResponse.status) {
        setSuburbList(suburbResponse?.data);
        setLoadingSuburb(false);
      }
    } catch {
      ErrorNotificationMsg(t("Error fetching suburb"));
      setLoadingSuburb(true);
    }
  };
  const handlePostalChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      postcode_name: value,
      // suburb_id: [],

      // zone: null,
    }));
    // formRef.current.setFieldsValue({ suburb: undefined });
    // setSuburbList([]);
    // getSuburbByPostcode(value);
  };

  const handleSuburbChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      suburb_id: value,
      // postcode_name: [],
      // zone: null,
    }));
    // formRef.current.setFieldsValue({ postcode: undefined });
    // setPostalList([]);
    // getPostalBySuburb(value);
  };
  // const getPostalBySuburb = async (suburbIds) => {
  //   setLoadingPostal(true);
  //   try {
  //     const payload = { suburb_id: [suburbIds] };  // Prepare the payload with zoneId array
  //     const postalResponse = await patchRequest(
  //       "package-model/suburb-by-postcode-filter/",
  //       payload
  //     );
  //     if (postalResponse.status) {
  //       setPostalList(postalResponse?.data);
  //       setLoadingPostal(false);
  //     }
  //   } catch {
  //     ErrorNotificationMsg(t("Error fetching postal"));
  //     setLoadingPostal(true);
  //   }
  // };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      // driverForm.resetFields(); // Reset the driver form fields
      setPopConfirmVisible(false); // Close the Popconfirm
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "parcel_no" && sortOrder === "ascend") {
      sortingEnumKey = "parcel_no";
    }
    if (sortField === "parcel_no" && sortOrder === "descend") {
      sortingEnumKey = "-parcel_no";
    }
    if (sortField === "sequence_no" && sortOrder === "ascend") {
      sortingEnumKey = "sequence_no";
    }
    if (sortField === "sequence_no" && sortOrder === "descend") {
      sortingEnumKey = "-sequence_no";
    }

    if (sortField === "hawb" && sortOrder === "ascend") {
      sortingEnumKey = "hawb";
    }
    if (sortField === "hawb" && sortOrder === "descend") {
      sortingEnumKey = "-hawb";
    }
    if (sortField === "unrouted" && sortOrder === "ascend") {
      sortingEnumKey = "unrouted";
    }
    if (sortField === "unrouted" && sortOrder === "descend") {
      sortingEnumKey = "-unrouted";
    }
    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }

    if (sortField === "is_scanned" && sortOrder === "ascend") {
      sortingEnumKey = "is_scanned";
    }
    if (sortField === "is_scanned" && sortOrder === "descend") {
      sortingEnumKey = "-is_scanned";
    }
    if (sortField === "latitude" && sortOrder === "ascend") {
      sortingEnumKey = "latitude";
    }
    if (sortField === "latitude" && sortOrder === "descend") {
      sortingEnumKey = "-latitude";
    }
    if (sortField === "longitude" && sortOrder === "ascend") {
      sortingEnumKey = "longitude";
    }
    if (sortField === "longitude" && sortOrder === "descend") {
      sortingEnumKey = "-longitude";
    }
    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb__area";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb__area";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode__pincode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode__pincode";
    }
    if (sortField === "assigned_to" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__name";
    }
    if (sortField === "assigned_to" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__name";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }
    if (sortField === "customer_code" && sortOrder === "ascend") {
      sortingEnumKey = "customer_code";
    }
    if (sortField === "customer_code" && sortOrder === "descend") {
      sortingEnumKey = "-customer_code";
    }
    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    if (sortField === "customer_address" && sortOrder === "ascend") {
      sortingEnumKey = "customer_address";
    }
    if (sortField === "customer_address" && sortOrder === "descend") {
      sortingEnumKey = "-customer_address";
    }
    if (sortField === "description_of_goods" && sortOrder === "ascend") {
      sortingEnumKey = "description_of_goods";
    }
    if (sortField === "description_of_goods" && sortOrder === "descend") {
      sortingEnumKey = "-description_of_goods";
    }
    if (sortField === "count" && sortOrder === "ascend") {
      sortingEnumKey = "count";
    }

    if (sortField === "count" && sortOrder === "descend") {
      sortingEnumKey = "-count";
    }
    if (sortField === "landed" && sortOrder === "ascend") {
      sortingEnumKey = "landed";
    }
    if (sortField === "landed" && sortOrder === "descend") {
      sortingEnumKey = "-landed";
    }
    if (sortField === "weight" && sortOrder === "ascend") {
      sortingEnumKey = "weight";
    }
    if (sortField === "weight" && sortOrder === "descend") {
      sortingEnumKey = "-weight";
    }
    if (sortField === "shipper_code" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_code";
    }
    if (sortField === "shipper_code" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_code";
    }
    if (sortField === "shipper_name" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_name";
    }
    if (sortField === "shipper_name" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_name";
    }
    if (sortField === "shipper_address" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_address";
    }
    if (sortField === "shipper_address" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_address";
    }
    if (sortField === "shipper_city" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_city";
    }
    if (sortField === "shipper_city" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_city";
    }
    if (sortField === "shipper_state" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_state";
    }
    if (sortField === "shipper_state" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_state";
    }
    if (sortField === "shipper_postcode" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_postcode";
    }
    if (sortField === "shipper_postcode" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_postcode";
    }
    if (sortField === "shipper_country" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_country";
    }
    if (sortField === "shipper_country" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_country";
    }
    if (sortField === "origin" && sortOrder === "ascend") {
      sortingEnumKey = "origin";
    }
    if (sortField === "origin" && sortOrder === "descend") {
      sortingEnumKey = "-origin";
    }
    if (sortField === "port" && sortOrder === "ascend") {
      sortingEnumKey = "port";
    }
    if (sortField === "port" && sortOrder === "descend") {
      sortingEnumKey = "-port";
    }
    if (sortField === "total_value" && sortOrder === "ascend") {
      sortingEnumKey = "total_value";
    }
    if (sortField === "total_value" && sortOrder === "descend") {
      sortingEnumKey = "-total_value";
    }
    if (sortField === "goods_currency" && sortOrder === "ascend") {
      sortingEnumKey = "goods_currency";
    }
    if (sortField === "goods_currency" && sortOrder === "descend") {
      sortingEnumKey = "-goods_currency";
    }
    if (sortField === "sac" && sortOrder === "ascend") {
      sortingEnumKey = "sac";
    }
    if (sortField === "sac" && sortOrder === "descend") {
      sortingEnumKey = "-sac";
    }
    if (sortField === "sub_master" && sortOrder === "ascend") {
      sortingEnumKey = "sub_master";
    }
    if (sortField === "sub_master" && sortOrder === "descend") {
      sortingEnumKey = "-sub_master";
    }
    if (sortField === "pkg_type" && sortOrder === "ascend") {
      sortingEnumKey = "pkg_type";
    }
    if (sortField === "pkg_type" && sortOrder === "descend") {
      sortingEnumKey = "-pkg_type";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "ascend") {
      sortingEnumKey = "cyber_vendor_account";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "descend") {
      sortingEnumKey = "-cyber_vendor_account";
    }
    if (sortField === "customs_code" && sortOrder === "ascend") {
      sortingEnumKey = "customs_code";
    }
    if (sortField === "customs_code" && sortOrder === "descend") {
      sortingEnumKey = "-customs_code";
    }
    if (sortField === "fr_reference" && sortOrder === "ascend") {
      sortingEnumKey = "fr_reference";
    }
    if (sortField === "fr_reference" && sortOrder === "descend") {
      sortingEnumKey = "-fr_reference";
    }
    return sortingEnumKey;
  };
  const handleReset = () => {
    setState({
      ...state,
      search: "",
      pagesize: state?.pagesize,
    });

    form.setFieldsValue({ search: "" });
  };

  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "-id",
      // pagesize: 10,
      pagesize: state?.pagesize,
      search: "",
      total: 0,
    });
  };
  const handleStartDateChange = (date) => {
    // Assuming 'date' is already a Moment.js object representing both date and time
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setStartDate(formattedDate);
  };
  const handleResetFilter = () => {
    setState({
      // ...state,
      page: 1,
      ordering: "-id",
      pagesize: state?.pagesize,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
    setStartDate(null);
    setZones([]);
    setSuburbList([]);
    setPostalList([]);
    setZones([]);
    setCheckedRouted("False");
    // setStates([]);
    formRef.current.setFieldsValue({
      state: undefined, // Set to undefined to keep placeholder
      zone: undefined, // Set to undefined to keep placeholder
      unrouted: false,
      // zone: undefined,   // Set to undefined to keep placeholder
      suburb: undefined, // Set to undefined to keep placeholder
      created_date: undefined,
      driver_id: undefined,
      postcode: undefined,
      // suburb: response.data.results.data.country_name,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
    setState((prevState) => ({
      ...prevState,
      page: 1,
      search: "",
      pagesize: state?.pagesize,
    }));
    setReload(!reload);
    // if (e?.target?.checked !== true) {

    // }
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // setSelectedRow(selectedRowKeys);
      // setSelectedRowParcels(parcels);
      // setSelectedRecords(selectedRows); // Store full record objects

      const hasSelectedRows = selectedRows?.length > 0;
      handleCheckboxChangeDisbale(hasSelectedRows);
      const shouldEnableAddRouteButton =
        hasSelectedRows &&
        selectedRows?.every(
          (row) =>
            row?.is_scanned === true &&
            // row.assigned_to === "unassigned" &&
            (row?.parcel_no === null || row?.parcel_no === 0)
        );
      setShowAddRouteButton(!shouldEnableAddRouteButton);
      const allRowsHaveParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) !== ""
      );
      const allRowsHaveEmptyParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) === ""
      );
      // const allRowsHaveParcelNo = selectedRows.every(row => row.parcel_no && row.parcel_no.trim() !== '');
      setShowViewOptimizeButton(allRowsHaveParcelNo);
      // const allRowsHaveEmptyParcelNo = selectedRows.every(row => !row.parcel_no || row.parcel_no.trim() === '');
      setShowOptimizeButton(allRowsHaveEmptyParcelNo);
    },
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow?.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);

      setSelectedRecords(selectedRows); // Store full record objects

      const hasSelectedRows = selectedRows?.length > 0;
      handleCheckboxChangeDisbale(hasSelectedRows);
      const shouldEnableAddRouteButton =
        hasSelectedRows &&
        selectedRows?.every(
          (row) =>
            row?.is_scanned === true &&
            // row.assigned_to === "unassigned" &&
            (row?.parcel_no === null || row?.parcel_no === 0)
        );
      setShowAddRouteButton(!shouldEnableAddRouteButton);
      const allRowsHaveParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) !== ""
      );
      const allRowsHaveEmptyParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) === ""
      );
      // const allRowsHaveParcelNo = selectedRows.every(row => row.parcel_no && row.parcel_no.trim() !== '');
      setShowViewOptimizeButton(allRowsHaveParcelNo);
      // const allRowsHaveEmptyParcelNo = selectedRows.every(row => !row.parcel_no || row.parcel_no.trim() === '');
      setShowOptimizeButton(allRowsHaveEmptyParcelNo);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow?.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );

      setSelectedRow(updatedSelectedRowKeys);
      setSelectedRecords(selectedRows); // Store full record objects

      const hasSelectedRows = selectedRows?.length > 0;
      handleCheckboxChangeDisbale(hasSelectedRows);
      const shouldEnableAddRouteButton =
        hasSelectedRows &&
        selectedRows.every(
          (row) =>
            row?.is_scanned === true &&
            // row.assigned_to === "unassigned" &&
            (row?.parcel_no === null || row?.parcel_no === 0)
        );
      setShowAddRouteButton(!shouldEnableAddRouteButton);
      const allRowsHaveParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) !== ""
      );
      const allRowsHaveEmptyParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) === ""
      );

      setShowViewOptimizeButton(allRowsHaveParcelNo);

      setShowOptimizeButton(allRowsHaveEmptyParcelNo);
    },
    selectedRowKeys: selectedRow,
  };
  const handleOptimizedRoute = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("route/package-list-formatted/", {
        package_list: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("package route optimized successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };
  const handleArchive = async (id = []) => {
    // let ids = selectedRow;
    // if (ids.length === 0) {
    //   ids.push(id);
    // }
    let ids = [...selectedRow];
    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest(
        "package-model/archive-package-model/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("package_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
      // ErrorNotificationMsg(error);
    }
  };

  const handleEdit = (id) => {
    setpackageId(id);
  };

  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Packages Within The Organization.
                </span>
              }
            > */}
            <h3>{t("Add Route")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Add Route")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec">
        <div className="addRoute-wrp">
          <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            libraries={libraries}
          >
            <Spin spinning={""}>
              <Form
                form={form}
                layout="vertical"
                // onFinish={onFinish}
                onValuesChange={handleFormChange}
                initialValues={address}
                ref={formRef}
              >
                <Row gutter={10} className="addRoutModal">
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    lg={12}
                    className="TextFeild gutter-row"
                  >
                    <Form form={driverForm} autoComplete="off" ref={formRef}>
                      <Form.Item
                        name="driver"
                        label={t("assign_driver")}
                        rules={[
                          {
                            required: true,
                            message: t("val_driver"),
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("pl_assign_driver")}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                          onChange={(value) => handleDriverFilter(value)}
                        >
                          {driverList?.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {/* </Popconfirm> */}
                    </Form>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={8}
                    lg={12}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="created_at" label={t("Date")}>
                      <DatePicker
                        placeholder={t("pl_date")}
                        format="DD-MM-YYYY"
                        showTime={false}
                        showNow={false}
                        disabledDate={disabledDate}
                        allowClear={false}
                        // value={deliverydate}
                        value={address?.created_at}
                        onChange={handleDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="route_name" label={t("Route Name")}>
                      <Input
                        placeholder={t("Route")}
                        name="route_name"
                        value={address.route_name}
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12}>
                    <Collapse defaultActiveKey={["1"]}>
                      <Panel header="1. Start Location" key="1">
                        <Row gutter={10}>
                          <Col xs={24} md={12} className="TextFeild gutter-row">
                            <Form.Item
                              name="start_street_address"
                              label={t("street_address")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>{t("var_street_address")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <AutoComplete
                                id="start_street_address"
                                placeholder={t("pl_street_address")}
                                options={options}
                                onSearch={handleSearch}
                                onSelect={handleSelect}
                                value={address.start_street_address}
                                onChange={(value) => {
                                  setAddress((prevstate) => ({
                                    ...prevstate,
                                    start_street_address: value,
                                  }));
                                  form.setFieldsValue({
                                    start_street_address: value,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={12} className="TextFeild gutter-row">
                            <Form.Item
                              name="start_suburb"
                              label={t("pl_suburb")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>{t("val_select_suburb")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("pl_enter_suburb")}
                                name="start_suburb"
                                value={address.start_suburb}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setAddress((prevstate) => ({
                                    ...prevstate,
                                    start_suburb: value,
                                  }));
                                  form.setFieldsValue({
                                    start_suburb: value,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12} className="TextFeild gutter-row">
                            <Form.Item
                              name="start_state"
                              label={t("pl_state_name")}
                              rules={[
                                {
                                  required: true,
                                  message: <Trans>{t("val_state")}</Trans>,
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("pl_enter_state")}
                                name="start_state"
                                value={address.start_state}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setAddress((prevstate) => ({
                                    ...prevstate,
                                    start_state: value,
                                  }));
                                  form.setFieldsValue({
                                    start_state: value,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12} className="TextFeild gutter-row">
                            <Form.Item
                              name="start_postcode"
                              label={t("pl_Postcode")}
                              rules={[
                                {
                                  required: true,
                                  message: <Trans>{t("val_Postcode")}</Trans>,
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("pl_enter_postcode")}
                                name="start_postcode"
                                value={address.start_postcode}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setAddress((prevstate) => ({
                                    ...prevstate,
                                    start_postcode: value,
                                  }));
                                  form.setFieldsValue({
                                    start_postcode: value,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} className="TextFeild gutter-row">
                            <Form.Item
                              name="start_additional_details"
                              label={t("additional_details")}
                              rules={[
                                {
                                  required: false,
                                  message: (
                                    <Trans>
                                      {t("pl_enter_additional_detail")}
                                    </Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("enter_additional_details")}
                                name="start_additional_details"
                                value={address.start_additional_details}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setAddress((prevstate) => ({
                                    ...prevstate,
                                    start_additional_details: value,
                                  }));
                                  form.setFieldsValue({
                                    start_additional_details: value,
                                  });
                                }}
                                // Adjust the number of rows as needed
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Panel>
                    </Collapse>
                  </Col>
                  <Col xs={24} md={12}>
                    <Collapse defaultActiveKey={["2"]}>
                      <Panel
                        header="2. End Location"
                        key="2"
                        style={{ textAlign: "left" }}
                      >
                        <EndLocationAddress
                          state={address}
                          form={driverForm}
                          setState={setAddress}
                          //   formRef={formRef}

                          // companyId={CompanyId}
                        />
                      </Panel>
                    </Collapse>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </LoadScript>

          <div className="mapfilter-body">
            <Form autoComplete="off" ref={formRef} className="gridformfilter">
              {authUserData()?.permission.includes("package|view_route") && (
                <Row className="mapfilter">
                  <Col className="TextFeild gutter-row">
                    <Form.Item name="created_date" label={t("pl_date")}>
                      <DatePicker
                        placeholder={t("pl_date")}
                        format="DD-MM-YYYY"
                        showTime={false}
                        allowClear={false}
                        onChange={(date, dateString) =>
                          handleStartDateChange(date, dateString)
                        }
                        style={{ width: "130px" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col className="TextFeild gutter-row">
                    <Form.Item name="state" label={t("pl_state")}>
                      <Select
                        name="state"
                        label={t("pl_state")}
                        placeholder={t("pl_select_state")}
                        value={state.state}
                        onChange={handleStateSelectChange}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "140px" }}
                      >
                        {states.map((state) => (
                          <Option key={state.id} value={state.id}>
                            {state.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item name="zone" label={t("pl_zone")}>
                      <Select
                        name="zone"
                        label={t("pl_zone")}
                        placeholder={t("val_zone")}
                        onChange={handlezoneChange}
                        value={state.zone}
                        showArrow
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "100px" }}
                      >
                        {zones?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.zone}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item name="suburb" label={t("pl_suburb")}>
                      <Select
                        placeholder={t("pl_select_suburb")}
                        name="suburb"
                        value={state.suburb}
                        showArrow
                        onChange={handleSuburbChange}
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "170px" }}
                        loading={loadingSuburb}
                        disabled={loadingSuburb}
                      >
                        {suburbList?.map((suburb) => (
                          <Option
                            key={suburb.suburb_id}
                            value={suburb.suburb_id}
                          >
                            {suburb.suburb_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item name="postcode" label={t("pl_postal")}>
                      <Select
                        placeholder={t("pl_select_postal")}
                        name="postcode"
                        value={state.postcode}
                        showArrow
                        onChange={handlePostalChange}
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "125px" }}
                        loading={loadingPostal}
                        disabled={loadingPostal}
                      >
                        {postalList?.map((postal) => (
                          <Option
                            key={postal.postcode_name}
                            value={postal.postcode_name}
                          >
                            {postal.postcode_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <>
                    {/* <Tooltip title="Apply Filter"> */}
                    <span>
                      <ButtonField
                        className="BlueShadowBtn"
                        type="primary"
                        htmlType="Apply"
                        label={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FilterOutlined style={{ fontSize: "16px" }} />{" "}
                            Apply Filter
                          </span>
                        }
                        onClick={handleApplyFilter}
                      />
                    </span>
                    {/* </Tooltip> */}

                    {startDate ||
                    stateFilter?.state ||
                    checkedRouted === "True" ||
                    stateFilter?.suburb_id.length !== 0 ||
                    stateFilter?.postcode_name.length !== 0 ||
                    stateFilter?.zone_id.length !== 0 ? (
                      // <Tooltip title="Reset Filters">
                      <span>
                        <ButtonField
                          className="BlueShadowBtn"
                          type="primary"
                          htmlType="Reset"
                          label={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <UndoOutlined
                                style={{ fontSize: "16px", color: "#fff" }}
                              />{" "}
                              Reset
                            </span>
                          }
                          onClick={handleResetFilter}
                        />
                      </span>
                    ) : (
                      // </Tooltip>
                      ""
                    )}
                    <Col className="searchwrp">
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("Unassigned Packages")}
                        name="unassigned"
                        valuePropName="checked"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_is_scanned")}</Trans>,
                        //   },
                        //   () => ({
                        //     validator(_, value) {
                        //       if (!value) {
                        //         return Promise.reject(
                        //           new Error(t("Please Is Scanned"))
                        //         );
                        //       }
                        //       return Promise.resolve();
                        //     },
                        //   }),
                        // ]}
                      >
                        {/* <Tooltip
                          title={t(
                            "Check this to see only unassigned packages"
                          )}
                        > */}
                        <Checkbox
                          onChange={handleCheckboxChange}
                          checked={checked}
                        ></Checkbox>
                        {/* </Tooltip> */}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="TextFeild gutter-row"
                    >
                      {/* <Form.Item
                      className="BrowsButtonSec"
                      label={t("Unrouted")}
                      name="unrouted"
                      valuePropName="checked"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: <Trans>{t("val_is_scanned")}</Trans>,
                    //   },
                    //   () => ({
                    //     validator(_, value) {
                    //       if (!value) {
                    //         return Promise.reject(
                    //           new Error(t("Please Is Scanned"))
                    //         );
                    //       }
                    //       return Promise.resolve();
                    //     },
                    //   }),
                    // ]}
                    >
                      <Checkbox
                        onChange={handleCheckboxChangeRouted}
                        // checkedRouted={checkedRouted}
                        checked={checkedRouted === 'True'}
                      ></Checkbox>
                    </Form.Item> */}
                    </Col>
                  </>
                  <SelectRouteModal
                    parcels={selectedRecords}
                    isModalVisible={isModalVisibleRoute}
                    selectedRow={selectedRow}
                    setIsModalVisible={setIsModalVisibleRoute}
                    setState={setState}
                  />
                </Row>
              )}
              <Space>
                <div className="searchwrp">
                  <Space direction="vertical">
                    <Form form={form}>
                      {authUserData()?.permission.includes(
                        "package|view_route"
                      ) && (
                        <Form.Item name="search" initialValue="">
                          <Search
                            // value={state.search}
                            prefix={
                              <img
                                src={SearchIcon}
                                alt="SearchIcon"
                                className="SearchIcon"
                                width={22}
                              />
                            }
                            placeholder={t("pl_search_list")}
                            onChange={searchCallbackDelayed}
                          />
                        </Form.Item>
                      )}
                    </Form>
                  </Space>
                </div>
                {authUserData()?.permission.includes("package|view_route") && (
                  <>
                    {state?.search ? (
                      // <Tooltip title="Reset search">
                      <Button
                        className="BlueShadowBtn"
                        type="primary"
                        htmlType="button"
                        onClick={() => handleReset()}
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <UndoOutlined
                            style={{ fontSize: "16px", color: "#fff" }}
                          />{" "}
                          Reset
                        </span>
                      </Button>
                    ) : (
                      // </Tooltip>
                      ""
                    )}
                  </>
                )}

                {authUserData()?.permission.includes(
                  "package|delete_route"
                ) && (
                  <>
                    {selectedRow.length > 0 && (
                      <Popconfirm
                        className="action"
                        title={t("pop_title")}
                        okText={t("pop_ok")}
                        cancelText={t("pop_cancel")}
                        placement="left"
                        onConfirm={() => handleArchive()}
                      >
                        <ButtonField
                          className="BlueShadowBtn"
                          type="primary"
                          htmlType="button"
                          label={
                            <>
                              <div
                                className="BlueShadowBtn"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <ArchiveButtonicon />
                                <span>{t("pl_archive")}</span>
                              </div>
                            </>
                          }
                        />

                        {/* )} */}
                      </Popconfirm>
                    )}
                  </>
                )}
                {authUserData()?.permission.includes(
                  "package|delete_route"
                ) && (
                  // <Tooltip placement="topLeft" title="View Archived Records">
                  <Link className="Archiveicon" to="/add-route/archive">
                    <Archiveicon />
                  </Link>
                  // </Tooltip>
                )}
                {authUserData()?.permission.includes("package|view_route") && (
                  <div className="gridiconswrap">
                    {/* <Tooltip title="Column Filter Options"> */}
                    <Dropdown
                      overlay={columnMenu}
                      trigger={["click"]}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={(visible) => setDropdownVisible(visible)}
                    >
                      <Button
                        type="primary"
                        shape="circle"
                        icon={<InsertRowLeftOutlined />}
                        onClick={() => setDropdownVisible(!dropdownVisible)}
                      />
                    </Dropdown>
                    {/* </Tooltip> */}
                  </div>
                )}
              </Space>
            </Form>
          </div>
          {authUserData()?.permission.includes("package|view_route") && (
            <Table
              scroll={{
                x: true,
              }}
              rowSelection={rowSelection}
              rowKey={(record) => record.id}
              columns={columns.filter((col) => !col.hidden)}
              dataSource={employeeList}
              loading={loading}
              pagination={{
                current: state.page, // Bind to state.page
                pageSize: state.pagesize, // Bind to state.pagesize
                pageSizeOptions: [
                  "10",
                  "50",
                  "100",
                  "200",
                  "300",
                  "400",
                  "500",
                  "600",
                  "700",
                  "800",
                  "900",
                  "1000",
                ],
                onShowSizeChange: (current, pageSize) => {
                  setState((prevState) => ({
                    ...prevState,
                    pagesize: pageSize,
                    page: current,
                  }));
                },
                total: totalCount,
                showTotal: (total) => `Total ${total} items`,
                showSizeChanger: true,
                locale: { items_per_page: "Items / Page" },
              }}
              onChange={handleTableChange}
            />
          )}
          {authUserData()?.permission.includes("package|add_route") && (
            <div className="btnwrp" style={{ textAlign: "right" }}>
              <Button
                type="primary"
                htmlType="submit"
                className="SaveGradiantBtn"
                onClick={() => handleSubmit()}
                loading={loadingButton}
                // disabled={!checkedDisable}
              >
                {t("pl_create_optimize_route")}
              </Button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};
export default AddRoutePickupPackage;
